export const getProfileLetterhead = (posProfile) => {
    const letterhead = posProfile?.letter_head;
    return typeof letterhead === "string" ? letterhead.trim() : "";
};

export const getTableOrderPrintFormat = (posProfile) => {
    const printFormat = posProfile?.customer_invoice_print_format;
    return typeof printFormat === "string" && printFormat.trim()
        ? printFormat.trim()
        : "Order Account Test";
};

export const buildDownloadPdfUrl = ({
    baseUrl = "",
    doctype,
    name,
    format,
    noLetterhead = 0,
    letterhead,
    settings = {},
    language = "en",
    extraParams = {},
}) => {
    const params = new URLSearchParams({
        ...extraParams,
        doctype,
        name,
        format,
        no_letterhead: String(noLetterhead),
        settings:
            typeof settings === "string" ? settings : JSON.stringify(settings),
        _lang: language,
    });

    const selectedLetterhead =
        typeof letterhead === "string" ? letterhead.trim() : "";
    if (selectedLetterhead) {
        params.set("letterhead", selectedLetterhead);
    }

    const normalizedBaseUrl = baseUrl ? baseUrl.replace(/\/$/, "") : "";
    return `${normalizedBaseUrl}/api/method/frappe.utils.print_format.download_pdf?${params.toString()}`;
};
